interface CardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
}

export default function Card({ children, title, className = '' }: CardProps) {
  return (
    <div className={`overflow-hidden rounded-lg border border-border bg-surface shadow-sm ${className}`}>
      {title && (
        <div className="border-b border-border bg-surface-muted/50 px-5 py-3.5">
          <h3 className="text-base font-semibold text-slate-800">{title}</h3>
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}
